import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-101d086e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "tabsWrapperRef",
  class: "tabs_wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新建分类")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TreeClassifyComponent = _resolveComponent("TreeClassifyComponent")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_ClassifyItemDialog = _resolveComponent("ClassifyItemDialog")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          class: "add_btn",
          onClick: _ctx.handleAddClick
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.tabsHandle.activeName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabsHandle.activeName) = $event)),
          onTabClick: _ctx.handleTabsClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsHandle.tabs, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: item.value,
                label: item.text,
                name: item.value,
                lazy: true
              }, {
                default: _withCtx(() => [
                  (_ctx.tabsHandle.activeName === item.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "tree_wrapper",
                        style: _normalizeStyle({ height: _ctx.tabsHandle.panelHeight + 'px' })
                      }, [
                        _createVNode(_component_TreeClassifyComponent, {
                          id: Number(item.value),
                          onOnEdit: _ctx.handleTreeEdit,
                          onOnCheck: _ctx.handleTreeCheck,
                          onOnAddChild: _ctx.handleTreeAddChild
                        }, null, 8, ["id", "onOnEdit", "onOnCheck", "onOnAddChild"])
                      ], 4))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onTabClick"])
      ], 512),
      (_ctx.classifyItemDialogHandle.visible)
        ? (_openBlock(), _createBlock(_component_ClassifyItemDialog, {
            key: 0,
            id: _ctx.classifyItemDialogHandle.id,
            pid: _ctx.classifyItemDialogHandle.pid,
            "order-num": _ctx.classifyItemDialogHandle.orderNum,
            level: _ctx.classifyItemDialogHandle.level,
            "product-id": _ctx.classifyItemDialogHandle.productId,
            "details-data": _ctx.classifyItemDialogHandle.detailsData,
            disabled: _ctx.classifyItemDialogHandle.disabled,
            onClickClassifyItemDialogClose: _ctx.clickClassifyItemDialogClose,
            onClickClassifyItemDialogSubmit: _ctx.clickClassifyItemDialogSubmit
          }, null, 8, ["id", "pid", "order-num", "level", "product-id", "details-data", "disabled", "onClickClassifyItemDialogClose", "onClickClassifyItemDialogSubmit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}